import * as docx from "docx";
import {
  AlignmentType,
  Header,
  HorizontalPositionAlign,
  HorizontalPositionRelativeFrom,
  ImageRun,
  TextRun,
  VerticalAlign,
  VerticalPositionAlign,
  VerticalPositionRelativeFrom,
} from "docx";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../../helper/dateTimeHelper";
import { logoBase64 } from "../base64";
import _ from "lodash";
import { C, breakLine, text } from "../../../company-office/request-vehicle/TemplateDocx/Template/common";
import saveAs from "file-saver";
import { CreateNotification } from "../../../../../components/notifier";

export const listOfDeliveryAndReceiptOfSmallSupplies = (item: any) => {
  const arr: any = item.eContent ? JSON.parse(item.eContent) : [];
  const totalAmount = _.sumBy(arr, "Amount");
  const TableMargins = {
    top: 150,
    bottom: 100,
    left: 50,
    right: 50,
  };

  const tableRow = arr.map((e: any) => {
    return new docx.TableRow({
      children: [
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              text: e.id - 1 + "",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          margins: TableMargins,
        }),
        new docx.TableCell({
          children: [new docx.Paragraph(e.NameSupplies)],
          margins: { left: 50 },
          verticalAlign: VerticalAlign.CENTER,
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              text: e.Unit,
              alignment: AlignmentType.CENTER,
            }),
          ],
          margins: { left: 50 },
          verticalAlign: VerticalAlign.CENTER,
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              text: e.Amount + "",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          margins: TableMargins,
        }),
        new docx.TableCell({
          children: [new docx.Paragraph(item.eUnitRoom)],
          margins: { left: 50 },
          verticalAlign: VerticalAlign.CENTER,
        }),
        new docx.TableCell({
          children: [
            new docx.Paragraph({
              text: item.eAssigneeStatus
                ? "Ngày thực hiện/ Bàn giao: " +
                  getDDMMYYYFormat(item.eAssigneeStatusDate) +
                  " - " +
                  getHHmmFormat(item.eAssigneeStatusDate)
                : "",
              alignment: AlignmentType.CENTER,
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          margins: { left: 50 },
        }),
        item.eAssigneeStatus
          ? new docx.TableCell({
              children: [
                // new docx.Paragraph({
                //   children: [
                //     new ImageRun({
                //       data: imageTick,
                //       transformation: {
                //         width: 60,
                //         height: 60,
                //       },
                //     }),
                //   ],
                //   alignment: AlignmentType.CENTER,
                // }),
                // new docx.Paragraph({
                //   children: [
                //     new docx.TextRun({
                //       text: item.eAssignee.split("|")[1],
                //       break: 2,
                //     })
                //   ],
                //   alignment: AlignmentType.CENTER,
                // }),
              ],
              margins: { left: 50 },
              verticalAlign: VerticalAlign.CENTER,
            })
          : new docx.TableCell({
              children: [
                new docx.Paragraph({
                  text: "",
                  alignment: AlignmentType.CENTER,
                }),
              ],
              margins: { left: 50 },
              verticalAlign: VerticalAlign.CENTER,
            }),
      ],
      cantSplit: true,
      height: { value: 600, rule: docx.HeightRule.AUTO },
    });
  });

  const doc = new docx.Document({
    sections: [
      {
        headers: {
          default: new Header({
            children: [
              new docx.Table({
                rows: [
                  new docx.TableRow({
                    children: [
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new ImageRun({
                                data: logoBase64,
                                transformation: {
                                  width: 100,
                                  height: 30,
                                },
                                floating: {
                                  zIndex: 5,
                                  horizontalPosition: {
                                    relative: HorizontalPositionRelativeFrom.PAGE,
                                    align: HorizontalPositionAlign.CENTER,
                                  },
                                  verticalPosition: {
                                    relative: VerticalPositionRelativeFrom.PAGE,
                                    align: VerticalPositionAlign.CENTER,
                                  },
                                },
                              }),
                            ],
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        margins: TableMargins,
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new TextRun({
                                text: "Biểu mẫu",
                                bold: true,
                                size: 18,
                                color: "000000",
                                italics: true,
                              }),
                            ],
                            alignment: AlignmentType.LEFT,
                          }),
                          new docx.Paragraph({
                            children: [
                              new TextRun({
                                text: "BẢNG KÊ GIAO NHẬN SỬ DỤNG VẬT TƯ NHỎ LẺ",
                                bold: true,
                                size: 24,
                                color: "000000",
                              }),
                            ],
                            spacing: {
                              before: 200,
                              after: 200,
                            },
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                        width: { size: 5000, type: docx.WidthType.DXA },
                        margins: TableMargins,
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                      new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            children: [
                              new TextRun({
                                text: "Mã số: BMTCKT012",
                                size: 24,
                              }),
                              new TextRun({
                                text: "Lần ban hành: 01",
                                size: 24,
                                break: 1,
                              }),
                              new TextRun({
                                text: "Ngày hiệu lực: ",
                                size: 24,
                                break: 1,
                              }),
                              new TextRun({
                                text: "Trang: 1/1",
                                size: 24,
                                break: 1,
                              }),
                            ],
                          }),
                        ],
                        width: { size: 3000, type: docx.WidthType.DXA },
                        margins: {
                          top: 0,
                          bottom: 100,
                          left: 100,
                          right: 100,
                        },
                        verticalAlign: VerticalAlign.CENTER,
                      }),
                    ],
                  }),
                ],
              }),
            ],
          }),
        },
        properties: {
          page: {
            margin: {
              top: 1134,
              right: 850,
              bottom: 1134,
              left: 1134,
            },
          },
        },
        children: [
          new docx.Paragraph({
            children: [
              new TextRun({
                text: "CÔNG TY DVMĐ SÂN BAY VIỆT NAM",
                color: "000000",
                size: 24,
                bold: true,
              }),
            ],
          }),
          new docx.Paragraph({
            children: [
              new TextRun({
                text: "PHÒNG CÔNG NGHỆ THÔNG TIN",
                color: "000000",
                size: 24,
                bold: true,
              }),
            ],
          }),
          new docx.Paragraph({
            children: [
              new TextRun({
                text: "Số: " + item.id,
                color: "000000",
                size: 24,
                bold: true,
              }),
            ],
          }),
          new docx.Paragraph({
            alignment: docx.AlignmentType.CENTER,
            heading: docx.HeadingLevel.HEADING_1,
            spacing: { before: 300, after: 300 },
            children: [
              new TextRun({
                text: "BẢNG KÊ GIAO NHẬN SỬ DỤNG VẬT TƯ NHỎ LẺ",
                color: "000000",
                bold: true,
                size: 26,
              }),
            ],
          }),
          new docx.Table({
            rows: [
              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "STT",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 500, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "TÊN HÀNG HOÁ, KÝ, MÃ HIỆU",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 2800, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "ĐVT",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 600, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "SL",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 600, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "ĐƠN VỊ SỬ DỤNG",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 2800, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "NGÀY NHẬN",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 2200, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "NGƯỜI NHẬN (Ký, ghi rõ họ tên)",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    width: { size: 2500, type: docx.WidthType.DXA },
                    margins: TableMargins,
                    verticalAlign: VerticalAlign.CENTER,
                  }),
                ],
                cantSplit: true,
                tableHeader: true,
                height: { value: 1000, rule: docx.HeightRule.EXACT },
              }),
              ...tableRow,

              new docx.TableRow({
                children: [
                  new docx.TableCell({
                    children: [new docx.Paragraph("")],
                    verticalAlign: VerticalAlign.CENTER,
                    margins: TableMargins,
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        children: [
                          new docx.TextRun({
                            text: "TỔNG CỘNG",
                            bold: true,
                          }),
                        ],
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    margins: { left: 50 },
                  }),
                  new docx.TableCell({
                    children: [new docx.Paragraph("")],
                    margins: { left: 50 },
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        text: totalAmount + "",
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    verticalAlign: VerticalAlign.CENTER,
                    margins: TableMargins,
                  }),
                  new docx.TableCell({
                    children: [new docx.Paragraph("")],
                    margins: { left: 50 },
                  }),
                  new docx.TableCell({
                    children: [
                      new docx.Paragraph({
                        text: "",
                        alignment: AlignmentType.CENTER,
                      }),
                    ],
                    margins: { left: 50 },
                  }),
                  item.eAssigneeStatus
                    ? new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            text: "",
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                        margins: { left: 50 },
                      })
                    : new docx.TableCell({
                        children: [
                          new docx.Paragraph({
                            text: "",
                            alignment: AlignmentType.CENTER,
                          }),
                        ],
                        margins: { left: 50 },
                      }),
                ],
                cantSplit: true,
                height: { value: 600, rule: docx.HeightRule.AUTO },
              }),
            ],
          }),

          breakLine(1),

          item.eApprovedByITHeadDate
            ? C.row(
                C.col(50, []),
                C.col(50, [
                  text(
                    [
                      { text: "Người lập", bold: true, size: 24 },
                      {
                        text:
                          "Ngày thực hiện/ Bàn giao: " +
                          getDDMMYYYFormat(item.eApprovedByITHeadDate) +
                          " - " +
                          getHHmmFormat(item.eApprovedByITHeadDate),
                        break: 1,
                        size: 20,
                      },
                      {
                        text: item.eApprovedByITHead.split("|")[2],
                        break: 1,
                        size: 20,
                      },
                    ],
                    { alignment: AlignmentType.CENTER }
                  ),
                  new docx.Paragraph({
                    children: [
                      // new ImageRun({
                      //   data: imageTick,
                      //   transformation: {
                      //     width: 60,
                      //     height: 60,
                      //   },
                      // }),
                      // new TextRun({})
                    ],
                    alignment: AlignmentType.CENTER,
                  }),
                  text(
                    { text: item.eApprovedByITHead.split("|")[1], break: 2 },
                    { alignment: AlignmentType.CENTER }
                  ),
                ])
              )
            : C.row(
                C.col(50, []),
                C.col(50, [
                  text([{ text: "Người lập", bold: true }], {
                    alignment: AlignmentType.CENTER,
                  }),
                ])
              ),
        ],
      },
    ],
  });

  docx.Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `P_GNVT_${item.id}.docx`);
    CreateNotification({
      title: "Thông báo",
      body: "Xuất bảng kê giao nhận vật tư nhỏ lẻ thành công",
      icon: "/icons/success.png",
    });
  });
};
